<template src="./index.html">
</template>
<script>
import {getdata} from'./data.js'
import minhead from '../../../../common/minHead/index.vue'
import config from '../../../../../../configHttp.js'
import invoice from '../invoice/index.vue'
import {wpsr_findDetails_api, wpsr_detailDelete_api, wpsr_initDownload_api, wpsr_getfapiaomx_api, wpsr_mxUpdateOrAdd_api} from "@/api/wpsr";
export default {
  name: '',
  components: {
	  minhead,
	  invoice
  },
  props: {
    initdata: {
      type: Object,
      default: () => ({})
    }
  },
  data: function() {
    return {
		searchdata:getdata().searchdata,
		searchlist:getdata().searchlist,
		outlist:[],
		headData:getdata().headData,
		pagination: getdata().pagination,
		tableData: [{}],
		shaidiag:false,
		tablekey:0,
		searchdiag:false,
		invoicediag:false,
    nsrsbhData:[], //纳税人信息下拉数据
    invoicedata:{}, //发票数据
    svldownlist:[], //税率下拉数据
    xmlxdownlist:[], //项目类型下拉数据
    xiaofxx:{} //销方信息
    };
  },
  created() {
    this.init();
  },
  methods: {
	  closeinvoicediag(){
	  	this.invoicediag=false
	  },
	  sizechange(e) {
	  	this.pagination.pageSize = e
	  },
	  currentChange(e) {
	  	this.pagination.pageNum = e
	  },
	  submitSearch() {
	  	this.pagination.pageNum = 1
	  	this.pagination.paginationkey++
      this.getMxdjInfo();
	  },
	  forRefresh(){
		  this.pagination.pageNum = 1
		  this.pagination.paginationkey++
	  },
	  forUpdateSearch(){
		  this.searchdiag=true
	  },
	  closeSearch(){
		   this.searchdiag=false
	  },
	  saveChange(e){
		   this.searchdiag=false
	  },
	  confirmfilter(e) {
	  	this.headData = e.chooselist
	  	this.outlist = e.nochooselist
	  	this.shaidiag = false
	  },
	  closeshaidiag(){
		  this.shaidiag=false
	  },
	  forback(){
		  this.$emit("forback","")
	  },
    //初始化数据
    init(){
      let params = {
        nsrsbh : this.initdata.nsrsbh
      }
      wpsr_initDownload_api(params).then(res =>{
        if (res.data.code == 1){
          this.nsrsbhData = res.data.data.nsrInfo;
          this.xmlxdownlist = res.data.data.xmmc;
          this.svldownlist = res.data.data.svl;
          this.xiaofxx = res.data.data.xiaofxx;
          this.getMxdjInfo();
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    //获取明细登记信息
    getMxdjInfo(){
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.current = this.pagination.pageNum;
      params.size =  this.pagination.pageSize;
      params.wpsrId = this.initdata.wpsrId;
      //查询数据
      wpsr_findDetails_api(params).then(res => {
        if(res.data.code == 1){
          this.tableData = res.data.data.records;
          this.pagination.total = res.data.data.total;
          this.pagination.paginationkey++;
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    //明细删除
    mxDelete(){
      let selectVal = this.$refs.tablebox.getSelectionval();
      if(selectVal.length < 1){
        this.$message.info("请选中数据再进行操作")
        return;
      }
      let _ids = selectVal.map(i => i.id);
      let params = {
        ids : _ids,
        wpsrId : this.initdata.wpsrId
      }
      wpsr_detailDelete_api(params).then(res => {
        if (res.data.code == 1 ){
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg)
        }
        this.getMxdjInfo();
      })
    },
    //编辑发票信息
    modifyInvoice(e){
      let params = {
        fapid: e.id
      }
      this.invoicedata = JSON.parse(JSON.stringify(e));
      wpsr_getfapiaomx_api(params).then(res => {
        if (res.data.code == 1){
          
          this.invoicedata.mx = res.data.data;
          this.invoicediag=true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //新增发票信息
    insertInvoice(){
      this.invoicedata = {
        wpsrId:this.initdata.wpsrId,
        shourrq : this.$timestampToStr(new Date(), "yyyyMMdd"),
        mx:[{
          jine:'',
          shuie:'',
        }]
      };
      this.invoicediag=true;
    },
    saveInvoice(e){
      wpsr_mxUpdateOrAdd_api(e).then(res => {
        if (res.data.code == 1){
          this.$message.success(res.data.msg);
          this.invoicediag = false;
          this.getMxdjInfo();
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //导出列表
    downloadList() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      let params = {
        wupsrFapExtendSearchInputDTO: {},
      };
      if (selectVal.length < 1) {
        params.wupsrFapExtendSearchInputDTO = JSON.parse(JSON.stringify(this.searchdata));
        params.wupsrFapExtendSearchInputDTO.sort = "id";
        params.wupsrFapExtendSearchInputDTO.order = "asc";
        params.wupsrFapExtendSearchInputDTO.wpsrId = this.initdata.wpsrId;
      } else {
        let _ids = selectVal.map((item) => item.id);
        params.ids = _ids;
      }
      params.json = getdata().tableJson;
      this.fileDownload(params);
    },
    fileDownload(val) {
      let params = {
        downUrl: config.baseURL + "/wpsr/details/export",
        typeObj: {
          toForm: false,
          fileType: "xlsx",
          fileName: "无票收入明细数据" + this.$timestampToStr(new Date(), "yyyyMMdd"),
          failUrl:this.$winURl
        },
        params: val,
      };
      this.$downloadcommon(params);
    }
  }
};
</script>


<style scoped lang="less">
@import url('./index.less');
</style>
